import { MoistureEquilibriumForm } from '../../components/MoistureEquilibriumForm'
import {
  MoistureEquilibriumProvider,
  useMoistureEquilibriumContext,
} from '../../context/moistureEquilibrium'
import { createFileRoute } from '@tanstack/react-router'

const MoistureEquilibriumCalculator = () => {
  const { moistureEquilibrium } = useMoistureEquilibriumContext()
  return (
    <div className="mt-6">
      <h4 className="mb-1 text-xl font-bold text-gray-800">
        Calculate equilibrium moisture content
      </h4>
      <h4 className="mb-2 text-gray-500">Percentage of fresh weight basis</h4>
      <div className="flex flex-row">
        <div className="sm:w-full md:w-1/2 xl:w-1/3">
          <div className="w-full rounded-md border border-gray-300 p-4">
            <MoistureEquilibriumForm />
          </div>
        </div>
        <div className="pl-4 sm:w-full md:w-1/2 xl:w-1/3 ">
          {moistureEquilibrium && (
            <div className="mb-4 w-full rounded-md border border-gray-300 p-4">
              <div>Result</div>
              <h3 className="text-lg font-bold">
                {moistureEquilibrium.toFixed(2)} %
              </h3>
            </div>
          )}
          <div className="w-full rounded-md border border-gray-300 p-4 text-sm">
            <span className="font-bold">About this tool</span>
            <p className="mb-2">
              This tool is based on Cromarty's equation and is intended to
              predict the moisture content (fresh weight basis) of the seeds
              when they are dried to equilibrium at a given temperature and
              relative humidity (IBPGR, 1990; Hay <em>et al</em>., 2022).
            </p>
            <p className="mb-2">
              Beside these two variables, the other parameter in the equation is
              the oil content of the seeds. In this tool, if you select 'Use
              preset' you will be given the option to select a species and
              hence, the oil content reported for this species. For some
              species, more than one oil content value may be available, in
              which case, you can select one of the preset values or enter your
              own average value. Cromarty's equation and hence this tool is
              intended to be used for seeds dried within the temperature and
              humidity ranges of 0-40°C and 10-70% RH for starchy seeds (e.g.
              cereals) and 15-25 and 10-70% RH for oily seeds (IBPGR, 1990).
            </p>
            <div>
              <span className="font-bold">References</span>
              <ul>
                <li className="mb-1">
                  Hay, F.R., Rezaei, S. and Buitink, J. (2022). Seed moisture
                  isotherms, sorption models, and longevity. Frontiers in Plant
                  Science, <span className="font-bold">13</span>, 891913.{' '}
                  <a
                    className="underline"
                    href="https://doi.org/10.3389/fpls.2022.891913"
                  >
                    https://doi.org/10.3389/fpls.2022.891913
                  </a>
                </li>
                <li>
                  IBPGR (1990).{' '}
                  <span className="italic">
                    Design of Seed Storage Facilities for Genetic Conservation
                  </span>
                  , Revised 1985 and 1990, International Board for Plant Genetic
                  Resources, Rome.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const WrappedMoistureEquilibriumForm = () => (
  <MoistureEquilibriumProvider>
    <MoistureEquilibriumCalculator />
  </MoistureEquilibriumProvider>
)

export const Route = createFileRoute('/viability/moisture-equilibrium')({
  component: WrappedMoistureEquilibriumForm,
})
